import React from 'react';
import ScrollEffectWrapper from './ScrollEffectWrapper';
import ProjectCard from './ProjectCard';
import topProject from '../data/topProject';

function topProjectSection() {
  return (
    <section className="section featured-projects-section">
      <div className="container">
        <ScrollEffectWrapper animationType="title">
          <div className="section-header">
            <h2 className="section-title">Featured Production Project</h2>
            <p className="section-subtitle">Highlighted work demonstrating end-to-end architecture, multi-tenancy, and production delivery for 7,000+ students.</p>
          </div>
        </ScrollEffectWrapper>

        <div className="top-projects-grid">
          {topProject.map((project, index) => (
            <ScrollEffectWrapper key={project.title} animationType="slide-up" delay={index * 150}>
              <ProjectCard project={project} featured />
            </ScrollEffectWrapper>
          ))}
        </div>
      </div>
    </section>
  );
}

export default topProjectSection;
